var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaflogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 542.071,
    height: 66,
    viewBox: "0 0 542.071 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 542.071,
    height: 66,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M88.215,39.738,96.609,25.2,105,39.738h12.533V37.643a.756.756,0,0,0-.1-.38L96.609,1.193,75.784,37.263a.764.764,0,0,0-.1.38v2.095Z",
    transform: "translate(-11.293 -0.178)",
    fill: "#98c33c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 41.808,
    height: 11.99,
    transform: "translate(63.995 52.911)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M47.373,10.7c-1.605,1.281-3.15,2.513-4.695,3.747-1.318,1.052-2.646,2.092-3.947,3.164-.545.449-.9.417-1.393-.134-4.263-4.755-9.571-5.645-15.484-4.025-2.039.558-3.6,1.788-3.9,4.031a4.684,4.684,0,0,0,2.993,5.232c3.244,1.4,6.637,2.446,9.884,3.838a94.968,94.968,0,0,1,10.858,5.13A15.618,15.618,0,0,1,49.68,45.636c.123,6.425-1.775,11.919-7.107,15.87a22.331,22.331,0,0,1-10.161,3.953c-7.605,1.153-15.012.59-21.995-2.915A24.034,24.034,0,0,1,.129,52.783c-.183-.321-.173-1.095.04-1.246,3.162-2.249,6.375-4.428,9.675-6.692.36.47.679.864.972,1.276,4.709,6.646,14.149,8.316,20.238,6.344,3.48-1.127,5.136-4.041,4.24-7.2a5.447,5.447,0,0,0-2.951-3.45c-2.514-1.225-5.112-2.283-7.7-3.346-3.668-1.507-7.49-2.7-11.018-4.476C2.769,28.516,2.352,17.126,5.671,10.6A17.958,17.958,0,0,1,16.843,1.542C25.385-1.148,33.569-.419,41.181,4.53A22.254,22.254,0,0,1,47.373,10.7",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M158.977,14.034v6.227c0,1.859.061,3.721-.023,5.578-.049,1.1.346,1.374,1.4,1.368,7.482-.04,14.964-.021,22.446-.021h1.623V39.738H159V65.059H144.8V63.666q0-30.424-.025-60.848c0-1.2.239-1.629,1.541-1.625q19.591.073,39.182,0c1.271-.005,1.6.373,1.564,1.6-.082,3.242-.077,6.488,0,9.73.027,1.178-.292,1.542-1.507,1.535-8.3-.052-16.607-.027-24.91-.027Z",
    transform: "translate(-21.602 -0.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M248.151,24.332a10.833,10.833,0,0,1-3.967-2.025l1.494-3.353a11.746,11.746,0,0,0,3.5,1.843,12.736,12.736,0,0,0,4.165.714,7.2,7.2,0,0,0,3.868-.83,2.514,2.514,0,0,0,1.278-2.191,2.125,2.125,0,0,0-.714-1.644,5.024,5.024,0,0,0-1.809-1.012q-1.1-.365-2.988-.83a34.681,34.681,0,0,1-4.3-1.262,7.076,7.076,0,0,1-2.821-1.975,5.32,5.32,0,0,1-1.178-3.635,6.2,6.2,0,0,1,1.046-3.5,7.072,7.072,0,0,1,3.153-2.506,12.782,12.782,0,0,1,5.163-.93,16.686,16.686,0,0,1,4.183.532,11.546,11.546,0,0,1,3.552,1.527l-1.361,3.352a13.427,13.427,0,0,0-3.186-1.36,11.935,11.935,0,0,0-3.22-.465,6.729,6.729,0,0,0-3.8.864,2.664,2.664,0,0,0-1.245,2.29,2.07,2.07,0,0,0,.714,1.627,5.145,5.145,0,0,0,1.809,1q1.1.366,2.988.83a31.438,31.438,0,0,1,4.249,1.245,7.276,7.276,0,0,1,2.838,1.976,5.207,5.207,0,0,1,1.179,3.585,6.118,6.118,0,0,1-1.046,3.486,7.1,7.1,0,0,1-3.17,2.489,12.9,12.9,0,0,1-5.179.929,17.734,17.734,0,0,1-5.195-.763",
    transform: "translate(-36.435 -0.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M282.989,23.552a11.431,11.431,0,0,1-4.481-4.283,11.755,11.755,0,0,1-1.626-6.124,11.761,11.761,0,0,1,1.626-6.125,11.437,11.437,0,0,1,4.481-4.283,14.07,14.07,0,0,1,12.814,0A11.476,11.476,0,0,1,300.285,7a11.749,11.749,0,0,1,1.626,6.142,11.744,11.744,0,0,1-1.626,6.141,11.47,11.47,0,0,1-4.482,4.266,14.07,14.07,0,0,1-12.814,0m10.591-3.287a7.568,7.568,0,0,0,2.921-2.922,8.372,8.372,0,0,0,1.062-4.2,8.378,8.378,0,0,0-1.062-4.2,7.58,7.58,0,0,0-2.921-2.922,8.892,8.892,0,0,0-8.367,0,7.565,7.565,0,0,0-2.92,2.922,8.364,8.364,0,0,0-1.063,4.2,8.358,8.358,0,0,0,1.063,4.2,7.554,7.554,0,0,0,2.92,2.922,8.892,8.892,0,0,0,8.367,0",
    transform: "translate(-41.314 -0.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M334.311,2.58a7.652,7.652,0,0,1,3.436,2.855,7.991,7.991,0,0,1,1.195,4.415,8.012,8.012,0,0,1-1.195,4.4,7.614,7.614,0,0,1-3.436,2.871,12.872,12.872,0,0,1-5.261,1H323.8v6.705h-4.315V1.585h9.561a12.872,12.872,0,0,1,5.261,1M333.132,13.27a4.166,4.166,0,0,0,1.461-3.419,4.168,4.168,0,0,0-1.461-3.419,6.632,6.632,0,0,0-4.282-1.195H323.8v9.229h5.046a6.632,6.632,0,0,0,4.282-1.2",
    transform: "translate(-47.671 -0.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M375.878,1.585V24.822h-4.315V14.863H359.545v9.959H355.23V1.585h4.315v9.594h12.018V1.585Z",
    transform: "translate(-53.004 -0.236)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 4.315,
    height: 23.238,
    transform: "translate(335.754 1.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M429.382,19.445H417.763l-2.291,5.378h-4.448L421.481,1.585h4.25L436.22,24.823h-4.514Zm-1.427-3.386L423.573,5.9l-4.349,10.158Z",
    transform: "translate(-61.329 -0.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M249.306,51.854v8.1h11.652v2.855H249.306V72.2h-3.32V48.966h16.4v2.888Z",
    transform: "translate(-36.704 -7.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M282.073,70.879a11.4,11.4,0,0,1-4.432-4.266,12.263,12.263,0,0,1,0-12.15,11.4,11.4,0,0,1,4.432-4.265,13.719,13.719,0,0,1,12.647,0,11.326,11.326,0,0,1,4.416,4.249,12.44,12.44,0,0,1,0,12.183,11.332,11.332,0,0,1-4.416,4.249,13.726,13.726,0,0,1-12.647,0m10.938-2.573a8.528,8.528,0,0,0,3.22-3.2,9.431,9.431,0,0,0,0-9.129,8.522,8.522,0,0,0-3.22-3.2,9.124,9.124,0,0,0-4.6-1.162,9.307,9.307,0,0,0-4.631,1.162,8.447,8.447,0,0,0-3.253,3.2,9.429,9.429,0,0,0,0,9.129,8.453,8.453,0,0,0,3.253,3.2,9.307,9.307,0,0,0,4.631,1.162,9.124,9.124,0,0,0,4.6-1.162",
    transform: "translate(-41.187 -7.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M321.188,69.814q-2.589-2.656-2.589-7.635V48.967h3.319V62.046q0,7.47,6.54,7.469a6.3,6.3,0,0,0,4.88-1.843q1.693-1.842,1.692-5.626V48.967h3.22V62.179q0,5.013-2.589,7.652a11.214,11.214,0,0,1-14.474-.017",
    transform: "translate(-47.538 -7.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M377.483,48.966V72.2H374.76L360.819,54.875V72.2H357.5V48.966h2.722l13.942,17.328V48.966Z",
    transform: "translate(-53.343 -7.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M396.985,48.966h9.793a14.157,14.157,0,0,1,6.54,1.461,10.742,10.742,0,0,1,4.432,4.1,12.432,12.432,0,0,1,0,12.117,10.744,10.744,0,0,1-4.432,4.1,14.157,14.157,0,0,1-6.54,1.461h-9.793Zm9.593,20.349a10.745,10.745,0,0,0,4.963-1.1,7.912,7.912,0,0,0,3.3-3.07,9.542,9.542,0,0,0,0-9.129,7.923,7.923,0,0,0-3.3-3.07,10.756,10.756,0,0,0-4.963-1.1H400.3V69.315Z",
    transform: "translate(-59.234 -7.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M450.816,66.394H438.467L435.912,72.2h-3.419l10.523-23.238H446.3L456.858,72.2h-3.486Zm-1.162-2.656-5.013-11.386-5.012,11.386Z",
    transform: "translate(-64.532 -7.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M475.653,51.854h-7.967V48.966h19.221v2.888h-7.967V72.2h-3.286Z",
    transform: "translate(-69.784 -7.306)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 3.32,
    height: 23.238,
    transform: "translate(427.381 41.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M526.049,70.879a11.413,11.413,0,0,1-4.431-4.266,12.268,12.268,0,0,1,0-12.15,11.41,11.41,0,0,1,4.431-4.265,13.722,13.722,0,0,1,12.648,0,11.332,11.332,0,0,1,4.416,4.249,12.442,12.442,0,0,1,0,12.183,11.338,11.338,0,0,1-4.416,4.249,13.729,13.729,0,0,1-12.648,0m10.939-2.573a8.53,8.53,0,0,0,3.22-3.2,9.431,9.431,0,0,0,0-9.129,8.524,8.524,0,0,0-3.22-3.2,9.128,9.128,0,0,0-4.6-1.162,9.306,9.306,0,0,0-4.631,1.162,8.442,8.442,0,0,0-3.253,3.2,9.431,9.431,0,0,0,0,9.129,8.448,8.448,0,0,0,3.253,3.2,9.306,9.306,0,0,0,4.631,1.162,9.128,9.128,0,0,0,4.6-1.162",
    transform: "translate(-77.591 -7.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M582.8,48.966V72.2h-2.724L566.131,54.875V72.2h-3.32V48.966h2.723l13.942,17.328V48.966Z",
    transform: "translate(-83.977 -7.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M485.886,19.444H474.267l-2.291,5.378h-4.448L477.985,1.584h4.25l10.489,23.238H488.21Zm-1.428-3.386L480.077,5.9l-4.349,10.158Z",
    transform: "translate(-69.76 -0.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M516.42,15.094l-3.685,3.784v5.942H508.42V1.584h4.315V13.5L524.221,1.584h4.847l-9.759,10.39,10.356,12.847h-5.046Z",
    transform: "translate(-75.862 -0.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M557.992,19.444h-11.62l-2.29,5.378h-4.448L550.09,1.584h4.25l10.489,23.238h-4.514Zm-1.428-3.386L552.182,5.9l-4.349,10.158Z",
    transform: "translate(-80.519 -0.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M582.188,24.331a10.836,10.836,0,0,1-3.967-2.025l1.494-3.353a11.746,11.746,0,0,0,3.5,1.843,12.742,12.742,0,0,0,4.167.714,7.192,7.192,0,0,0,3.867-.83,2.513,2.513,0,0,0,1.278-2.191,2.125,2.125,0,0,0-.714-1.644,5.025,5.025,0,0,0-1.809-1.012q-1.1-.365-2.988-.83a34.68,34.68,0,0,1-4.3-1.262,7.069,7.069,0,0,1-2.821-1.975,5.32,5.32,0,0,1-1.178-3.635,6.2,6.2,0,0,1,1.045-3.5,7.07,7.07,0,0,1,3.154-2.506,12.776,12.776,0,0,1,5.162-.93,16.68,16.68,0,0,1,4.182.532,11.552,11.552,0,0,1,3.553,1.527L594.454,6.6a13.426,13.426,0,0,0-3.187-1.36,11.922,11.922,0,0,0-3.219-.465,6.729,6.729,0,0,0-3.8.864A2.664,2.664,0,0,0,583,7.932a2.07,2.07,0,0,0,.714,1.627,5.14,5.14,0,0,0,1.809,1q1.1.366,2.987.83a31.5,31.5,0,0,1,4.25,1.245A7.279,7.279,0,0,1,595.6,14.6a5.2,5.2,0,0,1,1.178,3.585,6.118,6.118,0,0,1-1.045,3.486,7.1,7.1,0,0,1-3.17,2.489,12.9,12.9,0,0,1-5.178.929,17.735,17.735,0,0,1-5.2-.763",
    transform: "translate(-86.276 -0.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M633.518,1.584V24.821H629.2V14.862H617.186v9.959H612.87V1.584h4.316v9.594H629.2V1.584Z",
    transform: "translate(-91.447 -0.236)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaflogo);
export default __webpack_public_path__ + "static/media/SAFLOGO.605f4e360f52acbd5cb5a39200c30a97.svg";
export { ForwardRef as ReactComponent };